import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from './pages';
import { ThemeProvider } from './contexts/ThemeContext';
import { I18nProvider, useTranslation } from './i18n';
import en from './i18n/locales/en.json';


function App() {
  return (
    <ThemeProvider>
      <I18nProvider defaultLocale="en">
        <LocaleBootstrap />
        <Router>
          <div className="App">
            <Routes>
              {/* Main extraction page */}
              <Route path="/" element={<HomePage />} />
              
              
              {/* Redirect any unknown routes to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
      </I18nProvider>
    </ThemeProvider>
  );
}

function LocaleBootstrap() {
  const { register } = useTranslation();
  React.useEffect(() => {
    register('en', en as any);
  }, [register]);
  return null;
}

export default App;